// Driver-facing line item filter
// Requirement: show only TON line items in driver/vendor material views.

export const isDriverVisibleMaterial = (item: any): boolean => {
  if (!item) return false;

  const unit = (item.unit || "").toUpperCase();

  return unit === "TON";
};